import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import dipole from "./components/dipole/dipole";
import transverseQuadrupole from "./components/transverse-quadrupole/transverse-quadrupole";
import logitudinalQuadrupole from "./components/logitudinal-quadrupole/logitudinal-quadrupole";

const principle: Slide = {
  description:
    "A dipole (quadrupole) is made of two (four) monopoles delivering the same volume velocity Q in phase opposition (two in phase and two in phase opposition) and placed at a small distance d one from each other. Here two types of quadrupole are possible: transverse or longitudinal, with square or line arrangement. Look how changing the distance d between the sources influences the pressure field, depending on the radiated frequency. The phenomenon of the acoustic short circuit deserves a particular attention!",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          items: [{ name: "Dipole" }, { name: "Transverse quadrupole" }, { name: "Logitudinal quadrupole" }],
          options: {},
        },
      ],
      extraContent: [[], [], []],
      components: [dipole, transverseQuadrupole, logitudinalQuadrupole],
    },
  },
};

export default principle;
